import { Icon } from '@/lib/ui-kit/components/ui/Icon.component'
import { IconType } from '@/lib/ui-kit/components/ui/Icon.types'

export default function VerifiedBadge() {
  return (
    <div className="pointer-events-none inline-flex select-none items-center rounded-full bg-[#272727] text-base-light">
      <span className="paragraph-l py-1.5 pl-3 pr-2 font-semibold leading-none text-base-light">
        Verified
      </span>
      <div className="flex h-[31px] w-[31px] items-center justify-center rounded-full bg-gray-800">
        <Icon type={IconType.verified} className="text-white" />
      </div>
    </div>
  )
}
